import { Injectable } from '@angular/core';
import { OnInit } from "@angular/core";
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetamanagerService {

  constructor(private titleService: Title, private metaTagService: Meta) { }

  updateMetaTitle(title: string, description:string, keywords: string) {
    this.titleService.setTitle(title);

    this.metaTagService.updateTag(
      { name: 'keywords', content: keywords }
    );

    this.metaTagService.updateTag(
      { name: 'description', content: description }
    );
  }
}
